import React, { lazy } from 'react'
import ComponentLoader from './component-loader'

const Unauthorized = ComponentLoader(
  lazy(() => import('../layouts/unauthorized/unauthorized'))
)

const UnauthorizedRoutes = [
  {
    path: 'unauthorized',
    element: <Unauthorized />,
  },
  {
    path: '*',
    element: <Unauthorized />,
  },
]

export default UnauthorizedRoutes

